module.exports = __webpack_public_path__ + "fonts/perfect-serve.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/perfect-serve.woff
// module id = ./node_modules/@ps/common-core/dist/fonts/perfect-serve.woff
// module chunks = 1